import React from "react";

const Dashboard = () => {
  return (
    <div
      style={{
        padding: "2em 0",
        textAlign: "center",
        fontSize: "18px",
        fontWeight: "bold",
        borderBottom: "2em solid #FFD100",
      }}
    >
      Административен панел на Български пощи
    </div>
  );
};

export default Dashboard;
